import * as React from 'react'
import { useRef } from 'react';
import { AutoCompleteInput } from 'uxp/components'

interface IContextDataAutoCompleteProps {
    value: string;
    onChange: (v: string) => void;
    contextData: any;
}
export const ContextDataAutoComplete: React.FunctionComponent<IContextDataAutoCompleteProps> = (props) => {

    let inputRef = useRef(null)

    let ctx = props.contextData || {};
    let keys = Object.keys(ctx);
    let items = React.useMemo(() => {
        let sitems = [];
        for (let key of keys) {
            if (!key || !ctx[key]) continue;
            let ckeys = Object.keys(ctx[key]);
            for (let ck of ckeys) {
                sitems.push({ type: key, item: ck });
            }
        }
        return sitems;
    }, [ctx]);
    function expression(i: any) {
        return `\${${i.type}.${i.item}}`;
    }
    function renderSuggestions() {

        // let filteredItems = items.filter(x=>x.item.toLowerCase().indexOf(props.value.toLowerCase())>=0);
        return <div className='ac-cd-options'>
            {
                items.map((item, i) => {
                    return <div key={i} className='ac-cd-option'
                        onClick={() => {
                            // props.onChange(expression(item))
                            inputRef.current?.appendAtCursor(expression(item))
                        }}
                    >
                        <div className='ac-cd-option-type'>{item.type}</div>
                        <div className='ac-cd-option-value'>{item.item}</div>
                    </div>
                })
            }
        </div>
    }

    return <AutoCompleteInput
        value={props.value}
        onChange={props.onChange}
        autoFill={renderSuggestions}
        ref={inputRef}
        className="widget-designer-input"
    />;
};